import { ResourceType } from 'components/common/GlobalFiltersInPage/components/resourceTypeFilter/ResourceTypeFilter';

export const resourceTypeOptions: ISelectOption<ResourceType>[] = [
    { label: 'Material', value: 'MATERIAL' },
    { label: 'Work', value: 'WORK' },
    { label: 'Cost', value: 'COST' },
];
